"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtrasolarRace = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const Resources_1 = require("../../../Resources");
const Tags_1 = require("../../../cards/Tags");
class ExtrasolarRace {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.EXTRASOLAR_RACE;
        this.description = 'Increase your titanium production 1 step if you have at least 3 Power tags. Influence counts as Power tags.';
        this.revealedDelegate = PartyName_1.PartyName.TRANSHUMANS;
        this.currentDelegate = PartyName_1.PartyName.EMPOWER;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const powerTagsCount = player.getTagCount(Tags_1.Tags.ENERGY, 'raw');
            if (powerTagsCount + turmoil.getPlayerInfluence(player) >= 3) {
                player.addProduction(Resources_1.Resources.TITANIUM, 1, { log: true });
            }
        });
    }
}
exports.ExtrasolarRace = ExtrasolarRace;
//# sourceMappingURL=ExtrasolarRace.js.map